import { Component, OnInit, ViewChild } from '@angular/core';
import { CustomersService } from '../shared/customers.service';
import { Router } from '@angular/router';
import { Customer } from '../shared/customer';
import { MatDialog } from '@angular/material';
import { TranslateService } from '@ngx-translate/core';
import { ApiRoutes } from '../../../shared/api-routes';
import { MessageService } from '../../../core/services/message.service';
import { ConfirmDialogComponent } from '../../../shared/confirm-dialog/confirm-dialog.component';
import { DataTableComponent } from '../../../shared/data-table/data-table.component';

@Component({
  selector: 'app-customers-list',
  templateUrl: './customers-list.component.html',
  styleUrls: ['./customers-list.component.css']
})
export class CustomersListComponent implements OnInit {
  @ViewChild("tableChild") tableChild: DataTableComponent<Customer>;

  options = {
    columnTitles: ["CUSTOMERS.FIELDS.ID", "CUSTOMERS.FIELDS.FULL_NAME", "CUSTOMERS.FIELDS.EMAIL_ADDRESS", "CUSTOMERS.FIELDS.STATE",
      "CUSTOMERS.FIELDS.CITY", "CUSTOMERS.FIELDS.FULL_ADDRESS", "GENERAL.LABELS.ACTIONS"],
    columnReferences: ["id", "fullName", "email", "state", "city", "fullAddres", "actions"],
    actionButtons: { edit: true, delete: true }
  };
  pagePath: string = "api/client/page";
  searchText: string = '';
  search: any;

  constructor(private service: CustomersService, private apiRoutes: ApiRoutes, private router: Router, public dialog: MatDialog,
    private messageService: MessageService, private translate: TranslateService) {
  }

  ngOnInit() {
  }

  goToEdit(e: any) {
    this.router.navigate(["edit", e.id]);
  }

  openDeleteDialog(e: any) {

    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '680px',
      data: {
        entityText: "CUSTOMERS.SINGLE",
        title: "GENERAL.LABELS.DELETE",
        body: "DELETE_MODAL.QUESTION",
        entityId: e.fullName,
        cancelButtonText: "GENERAL.LABELS.CANCEL",
        confirmButtonText: "GENERAL.LABELS.DELETE",
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.service.delete(e.id).subscribe(data => {
          this.messageService.success('GENERAL.MESSAGE.TITLE_SUCCESS', 'GENERAL.MESSAGE.SUCCESS',
            {
              article: 'GENERAL.MESSAGE.THE_1',
              function: 'CUSTOMERS.SINGLE',
              action: 'GENERAL.MESSAGE.ACTIONS.ACTION_DELETE'
            });
          this.tableChild.loadPage();
        }, error => {
          this.messageService.error("Error", error.message);
        })
      }
    });
  }

  searchPant() {
    this.search = {
      searchText: this.searchText
    }
    this.tableChild.firstPage();
    this.tableChild.loadPage(this.search);
  }

}
